<template>
  <b-row class="campaign-filter-content-shares-where">

    <b-col v-bind="cols">
      <b-form-group :label="$t('jobs.labels.title')" label-for="title">
        <b-form-input id="title" :placeholder="$t('campaign-admin.placeholders.example-jobs')" v-model.trim="form.title"/>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols">
      <b-form-group label="URL" label-for="url">
        <b-form-input id="url" :placeholder="$t('campaign-admin.placeholders.example-url')" v-model.trim="form.url"/>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols">
      <b-form-group :label="$t('jobs.labels.campaign')" label-for="campaign">
        <b-form-select id="campaign" :options="campaignOptions" v-model="form.campaign"/>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="hasContentSharesV2Enabled">
      <b-form-group :label="$t('jobs.labels.tags')" label-for="tags">
        <multiselect
          id="tags"
          :options="[
            ...this.tagOptions
          ]"
          v-model="form.tag"
          :placeholder="$t('campaign-admin.placeholders.tags')"
          :searchable="true"
        />
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="hasContentCategoriesEnabled">
      <b-form-group :label="$t('jobs.labels.categories')" label-for="categories">
        <multiselect
          id="categories"
          :options="[
            ...this.categoryOptions
          ]"
          v-model="form.category"
          :placeholder="$t('campaign-admin.placeholders.categories')"
          :searchable="true"
          track-by="id"
          label="name"
        />
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="isRecruiterAdmin">
      <b-form-group :label="$t('jobs.labels.status')" label-for="status">
        <b-form-select id="status" :placeholder="$t('ctas.select-status')"
          :options="statusOptions" v-model="form.status"/>
      </b-form-group>
    </b-col>

  </b-row>
</template>

<script>
import { mapRoot, mapPreferences } from '@/mixins/root';
import Multiselect from 'vue-multiselect';
import gql from 'graphql-tag';

const FIND_CONTENT_CATEGORIES = gql`
  query GetContentCategories {
    company {
      id
      contentCategories(where: { deleted: false }) {
        id
        name
      }
    }
  }
`;

export default {
  props: {
    campaigns: {
      type: Array,
      default: null,
    },
    tagOptions: {
      type: Array,
      default: () => [],
    },
    orientation: {
      type: String,
      default: () => 'horizontal',
      validate: layout => [ 'horizontal', 'vertical' ].includes(layout),
    },
    value: {
      type: Object,
      default: null,
    },
  },
  components: {
    Multiselect
  },
  data: () => ({
    form: null,
    categoryOptions: [],
  }),
  created() {
    const form = {};
    if (this.value) {
      form.title = this.value.title_like || null;
      form.url = this.value.url_like || null;
      form.tag = this.value.tag || null;
      form.category = this.value.category || null;
      form.campaign = this.value.campaigns && this.value.campaigns.id
        ? this.value.campaigns.id
        : null;
    }

    this.form = form;
  },
  apollo: {
    contentCategories: {
      query: FIND_CONTENT_CATEGORIES,
      update(data) {
        const categories = data.company.contentCategories || [];
        this.categoryOptions = categories.sort((a, b) => a.name.localeCompare(b.name));
      },
      error(error) {
        console.error('Error fetching content categories:', error);
      },
    },
  },
  computed: {
    ...mapRoot([ 'company', 'isRecruiterAdmin' ]),
    ...mapPreferences([ 'featuresEnabled' ]),
    cols() {
      if (this.orientation === 'horizontal') {
        return { cols: 12, sm: 6, ...(this.hasContentSharesV2Enabled ? { lg: 3 } : { md: 4 }) };
      } else {
        return { cols: 12 };
      }
    },
    statusOptions() {
      return [
        { text: 'Active', value: 'ACTIVE' },
        { text: 'Inactive', value: 'INACTIVE' },
        { text: 'Deleted', value: 'DELETED' },
      ];
    },
    campaignOptions() {
      return [
        { text: this.$t('ctas.select-campaign'), value: null },
        ...(Array.isArray(this.campaigns) ? this.campaigns : []).map(({ id, title }) => ({ text: title, value: id })),
      ];
    },
    hasContentSharesV2Enabled() {
      return (this.featuresEnabled || []).includes('content-share-v2');
    },
    hasContentCategoriesEnabled() {
      return (this.featuresEnabled || []).includes('content-categories');
    },
  },
  debounceWatch: {
    form: {
      handler(form) {
        const where = {};

        if (form.title) {
          where.title_like = form.title;
        }
        if (form.url) {
          where.url_like = form.url;
        }
        if (form.tag) {
          where.tag = form.tag;
        }
        if (form.category) {
          where.category = form.category.id;
        }
        if (form.campaign) {
          where.campaigns = { id: form.campaign };
        }
        if (form.status && form.status !== 'ACTIVE') {
          where.status = form.status;
        }

        this.$emit('input', where);
      },
      wait: '1s',
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/campaign/FilterContentSharesWhere.vue